export default class AbstractPilsComponent
{
    constructor(element, pilsType)
    {
        this._pilsType = pilsType;
        this._element = element;
        this._productNumber = null;
    }

    init()
    {
        this._productNumber = this.fetchProductNumber();
    }

    fetchProductNumber()
    {
        return this._element.dataset.pilsProductNumber;
    }

    get productNumber()
    {
        return this._productNumber;
    }

    set productNumber(productNumber)
    {
        this._productNumber = productNumber;
    }

    get pilsType()
    {
        return this._pilsType;
    }
}
